const CANONICAL_FACEBOOK_PAGE_URL = 'https://www.facebook.com/people/NextCompli/61589469863754/';

const normalizeUrl = (value: string): string => {
  const trimmed = String(value || '').trim();
  if (!trimmed) {
    return '';
  }
  if (/^https?:\/\//i.test(trimmed)) {
    return trimmed;
  }
  return `https://${trimmed}`;
};

export const getFacebookPageUrl = (pageId?: string): string => {
  const configured = normalizeUrl(process.env.REACT_APP_FACEBOOK_PAGE_URL || '');
  const knownPage = !configured
    || /facebook\.com\/nextcompli\/?$/i.test(configured)
    || /facebook\.com\/1039543605916954\/?$/i.test(configured)
    || /profile\.php\?id=1039543605916954/.test(configured);
  if (configured && !knownPage) {
    return configured;
  }

  const normalizedPageId = String(pageId || '').trim();
  if (normalizedPageId && normalizedPageId !== '1039543605916954') {
    return `https://www.facebook.com/profile.php?id=${encodeURIComponent(normalizedPageId)}`;
  }

  return CANONICAL_FACEBOOK_PAGE_URL;
};

export const SOCIAL_LINKS = {
  facebook: getFacebookPageUrl((process.env.REACT_APP_FACEBOOK_PAGE_ID || '').trim()),
  x: 'https://x.com/nextcompli',
  linkedIn: 'https://www.linkedin.com/company/nextcompli',
  instagram: 'https://www.instagram.com/nextcompli_official/',
  youtube: 'https://www.youtube.com/@nextcompli',
  tiktok: 'https://www.tiktok.com/@nextcompli',
};
